/**
 * Edificações de bases abertas para os mapas (Rede e SCADA 3D) — Nexora Grid (frontend, US-3602).
 *
 * Criado em: 26/10/2026 · Última modificação: 26/10/2026 · Versão: 1.0.0
 *
 * Lê `/api/v1/edificacoes` (Open Buildings, Overture, OpenStreetMap — US-3601): GeoJSON com uso, altura, pavimentos,
 * setor e nó EPANET, mais a atribuição obrigatória das fontes. Cores por uso (iguais nos dois mapas).
 */
import { api } from "./api";

export type PropsEdificacao = { tipo: "edificacao" | "ponto"; nome: string; uso: string; area_m2: number | null; altura_m: number | null;
  pavimentos: number | null; altura_estimada: boolean; no_epanet: string | null; setor: string | null; fonte: string };
export type FeicaoEdificacao = { type: "Feature"; geometry: { type: "Polygon" | "Point"; coordinates: unknown }; properties: PropsEdificacao };
export type ColecaoEdificacoes = { type: "FeatureCollection"; features: FeicaoEdificacao[]; atribuicao: string[] };

export const COR_USO: Record<string, string> = { residencial: "#94a3b8", comercial: "#f59e0b", servico: "#38bdf8", desconhecido: "#64748b" };
export const NOME_USO: Record<string, string> = { residencial: "residencial", comercial: "comercial", servico: "serviço", desconhecido: "uso desconhecido" };

/** Município da operadora para as edificações: o da rede escolhida ou o primeiro cadastrado. */
export async function carregarEdificacoes(empresa: string, municipio: string): Promise<ColecaoEdificacoes> {
  return api<ColecaoEdificacoes>(`/v1/edificacoes?empresa=${empresa}&municipio=${encodeURIComponent(municipio)}`);
}

/** Centro (lon, lat) de uma feição (média dos vértices do polígono). */
export function centro(f: FeicaoEdificacao): [number, number] {
  if (f.geometry.type === "Point") return f.geometry.coordinates as [number, number];
  const anel = (f.geometry.coordinates as number[][][])[0];
  const n = anel.length - 1 || 1;
  return [anel.slice(0, n).reduce((s, p) => s + p[0], 0) / n, anel.slice(0, n).reduce((s, p) => s + p[1], 0) / n];
}
